import { useState } from "react";
import { BatteryLow, BatteryMedium, BatteryFull } from "lucide-react";
import { ChipGroup } from "@/components/Pickers";

const ENERGY = [["low", "Low", BatteryLow, "Running on empty"], ["okay", "Okay", BatteryMedium, "Getting by"], ["good", "Good", BatteryFull, "Ready for more"]];
const SLEEP = ["<6", "6-7", "7-8", "8+"];
const CIRC = ["busy", "travel", "sick", "period", "free day"];

export function EnergyCheck({ name, hour, onSubmit, busy }) {
  const [energy, setEnergy] = useState(null);
  const [sleep, setSleep] = useState(null);
  const [circ, setCirc] = useState([]);
  const hello = hour < 4 ? "Still up" : hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";

  if (busy) return (
    <div className="card p-10 text-center" data-testid="energy-shaping">
      <div className="mx-auto h-8 w-8 rounded-full border-2 border-t-transparent animate-spin" style={{ borderColor: "var(--phase)", borderTopColor: "transparent" }} />
      <p className="font-display text-xl mt-5">Shaping your day around how you feel…</p>
    </div>
  );
  return (
    <div className="card p-6 sm:p-8 rise" data-testid="energy-check">
      <h2 className="font-display text-3xl tracking-tight">{hello}, {name}.</h2>
      <p className="text-stone-600 mt-1.5">How's your energy right now? I'll fit today around it.</p>
      <div className="grid grid-cols-3 gap-2.5 mt-6">
        {ENERGY.map(([k, l, Icon, sub]) => (
          <button key={k} onClick={() => setEnergy(k)} data-testid={`energy-${k}`}
            className={`chip rounded-2xl border p-4 text-left ${energy === k ? "border-stone-900 bg-stone-900 text-white" : "border-stone-200 bg-white hover:border-stone-400"}`}>
            <Icon className="h-5 w-5 mb-3" strokeWidth={1.75} />
            <div className="font-semibold">{l}</div>
            <div className={`text-[11px] ${energy === k ? "text-white/70" : "text-stone-500"}`}>{sub}</div>
          </button>
        ))}
      </div>
      <div className="mt-6">
        <div className="text-sm font-semibold mb-2">Sleep last night <span className="font-normal text-stone-400">· optional</span></div>
        <ChipGroup options={SLEEP.map((s) => `${s}h`)} multi={false} value={sleep ? `${sleep}h` : null} onToggle={(o) => setSleep(sleep === o.slice(0, -1) ? null : o.slice(0, -1))} testid="sleep" />
      </div>
      <div className="mt-5">
        <div className="text-sm font-semibold mb-2">Anything about today? <span className="font-normal text-stone-400">· optional</span></div>
        <ChipGroup options={CIRC} value={circ} onToggle={(o) => setCirc(circ.includes(o) ? circ.filter((x) => x !== o) : [...circ, o])} testid="circ" />
      </div>
      <button disabled={!energy} onClick={() => onSubmit({ energy, sleep, circumstances: circ.map((c) => c.replace(" ", "_")) })} data-testid="energy-submit"
        className="btn-ink mt-7 w-full h-12 rounded-full font-semibold disabled:opacity-40">Shape my day</button>
    </div>
  );
}
